import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Flex, Result } from "antd";
import { t } from "i18next";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const info = useMemo(() => {
    return {
      title: location?.state?.title ?? `${t("TOAST.USPEH")}!`,
      subTitle:
        location?.state?.subTitle ??
        t("AKCIZNE_MARKICE.HVALA_VAM_STO_KORISTITE_USLUGE_PORTALA_EAKCIZE"),
    };
  }, [location]);

  const handleGoBack = () => {
    navigate(location?.state?.redirectPath || -1);
  };

  return (
    <Flex align="center" justify="center" style={{ height: "100%" }}>
      <Result
        status="success"
        title={info.title}
        subTitle={info.subTitle}
        extra={[
          <Button
            key="goBackButton"
            icon={<ArrowLeftOutlined />}
            onClick={handleGoBack}
            style={{ border: "none", boxShadow: "unset" }}
          >
            {t("COMMON.NAZAD")}
          </Button>,
        ]}
      />
    </Flex>
  );
};

export default SuccessPage;
